// LAN-212: Rails-sourced PostHog events carry no session id, so no per-session
// question is answerable. Rails does not derive one — a server-side definition
// would disagree with the client's about where a sitting begins and ends. The
// client passes its own PostHog $session_id instead, on the same header
// mechanism as X-Langua-Client (LAN-424) and X-Langua-Platform (LAN-427).
export const SESSION_HEADER = 'X-Langua-Session';

// posthog-js is loaded by the snippet in app/views/layouts/_posthog.html.erb,
// so it is a global rather than an import, and it is genuinely absent on pages
// that do not render that partial and while the snippet is still loading.
//
// get_session_id() is posthog-js's own accessor for the value it already puts
// on client-side events. Reading it here is what makes a Rails event and a
// client event agree on the sitting.
export function languaSessionId() {
  try {
    const client = typeof posthog !== 'undefined' ? posthog : window.posthog;
    if (!client || typeof client.get_session_id !== 'function') return null;

    const id = client.get_session_id();
    return typeof id === 'string' && id.length > 0 ? id : null;
  } catch {
    // Analytics attribution must never break a request. Rails records an
    // absent session as absent, which is the honest result here.
    return null;
  }
}

// Spread into a headers object. Absent stays absent: no header at all rather
// than an empty one, because Rails treats a malformed value the same as a
// missing one and an empty header only adds noise.
//
//   headers: { 'X-Langua-Client': 'web', ...languaSessionHeader() }
export function languaSessionHeader() {
  const id = languaSessionId();
  return id === null ? {} : { [SESSION_HEADER]: id };
}
